import { useContext } from 'react';
import AuthContext, { AuthContextType } from '../AuthContext';

export default function useAuth(): AuthContextType {
    return useContext(AuthContext);
}
